export default __webpack_public_path__ + "static/media/OSMOS_NEBBIA_C2_GRIP_120X120_03.2db535dc.jpg";